import React from 'react';
import { Ic } from './Icons';

/**
 * PageShell — wraps a page with the consistent header (section number, title, subtitle, actions).
 */
export default function PageShell({ section, number, title, subtitle, actions, children }) {
  return (
    <>
      <div className="ta-head">
        <div className="ta-head-left">
          {number && <div className="ta-section-n">§ {number}</div>}
          <h1 className="ta-title">{title}</h1>
          {subtitle && <div className="ta-sub">{subtitle}</div>}
        </div>
        {actions && <div className="ta-actions">{actions}</div>}
      </div>
      <div className="ta-body">{children}</div>
    </>
  );
}

export function Btn({ kind = "ghost", icon, children, onClick, className = '', ...rest }) {
  const iconNode = typeof icon === 'string' ? Ic[icon] : icon;
  return (
    <button
      type="button"
      className={`ta-btn ta-btn-${kind} ${className}`.trim()}
      onClick={onClick}
      {...rest}
    >
      {iconNode && <span className="ta-btn-ic">{iconNode}</span>}
      {children != null && <span>{children}</span>}
    </button>
  );
}

export function Pill({ tone = "muted", children }) {
  const cls = tone === 'ok' ? 'ta-pill-ok'
    : tone === 'warn' ? 'ta-pill-warn'
    : tone === 'accent' ? 'ta-pill-accent'
    : tone === 'danger' ? 'ta-pill-danger'
    : '';
  return <span className={`ta-pill ${cls}`}>{children}</span>;
}

export function Eyebrow({ children, style }) {
  return <div className="eyebrow" style={style}>{children}</div>;
}

export const fmtEUR = (n) => (n ?? 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
